import { Component, EventEmitter, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService, MessageService, TableColumns, TableConfiguration, params } from 'brainloper-ui';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { Provider } from 'src/app/models/administration/provider';
import { User } from 'src/app/models/administration/user';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { enumProviderType } from 'src/app/models/commos/enum-provider-type';

@Component({
    selector: 'app-modal-maintenace-orders',
    templateUrl: './modal-maintenace-orders.component.html',
    styleUrls: ['./modal-maintenace-orders.component.scss'],
    standalone: false
})
export class ModalMaintenanceOrdersComponent implements OnInit {


  public urlGetTablaTerceros: string = `${EndpointDictionary.Provider.PROVIDER_TABLE}`
  public urlGetTablaUsuarios: string = `${EndpointDictionary.User.USER_TABLE}`
  private urlPostUsuariosOT: string = `${EndpointDictionary.UserOrder.CRUD_USER_ORDER_DATA}`

  //chip responsable

  private tipoResponsable: string = ''
  public selectable: boolean = true;
  public removable: boolean = true;
  public chipResponsable = []


   //tabla terceros
   public paramsProviders: params[] = [{ id: 'providerTypeId', value: enumProviderType.MATENIMIENTO }]
   public titleTerceros: string = 'Terceros'
   public recargarTablaTerceros = new EventEmitter<any>()
   public configurationTerceros: TableConfiguration = {
     edit: false,
     add: false,
     delete: false,
     selectable: false,
     primaryKey: 'id'
   }
   public columnasTerceros: TableColumns<Provider>[] = [
     {
       ID: 'providerName',
       label: 'Nombre',
       type: 'text',
       style: {
         textAlign: 'center'
       },
     },
     {
       ID: 'companyPhone',
       label: 'Telefono',
       type: 'text',
       style: {
         textAlign: 'center'
       },
     },
     {
       ID: 'city',
       label: 'Ciudad',
       type: 'text',
       style: {
         textAlign: 'center'
       },
     },
     {
       ID: 'address',
       label: 'Direccion',
       type: 'text',
       style: {
         textAlign: 'center',
         movil: 'no-movil'
       },
     },
     {
          ID: 'email',
          label: 'Email',
          type: 'text',
          style: {
            textAlign: 'center',
            movil: 'no-movil',
          },
      },

   ]

   //tabla usuarios
   public titleUsuarios: string
   public recargarTablaUsuarios = new EventEmitter<any>()
   public configurationUsuarios: TableConfiguration = {
     edit: false,
     add: false,
     delete: false,
     selectable: false,
     primaryKey: 'userId'
   }
   public columnasUsuarios: TableColumns<User>[] = [
     {
       ID: 'user',
       label: 'Usuario',
       type: 'text',
       style: {
         textAlign: 'center'
       },
     },
     {
       ID: 'name',
       label: 'Nombre',
       type: 'text',
       style: {
         textAlign: 'center'
       },
     },
     {
       ID: 'jobTitle',
       label: 'Cargo',
       type: 'text',
       style: {
         textAlign: 'center'
       },
     },
     {
       ID: 'area',
       label: 'Area',
       type: 'text',
       style: {
         textAlign: 'center',
         movil: 'no-movil'
       },
     }
   ]

  constructor(
    public dialogRef: MatDialogRef<ModalMaintenanceOrdersComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private http: HttpService,
    private message: MessageService,


  ) { }

  ngOnInit(): void {

  }

  remove(data: params) {
    const index = this.chipResponsable.indexOf(data);

    if (index >= 0) {
      this.chipResponsable.splice(index, 1);
    }
  }

  clickFilaTerceros($event: Provider) {
    //console.log($event)
    this.tipoResponsable='tercero'
    for(let element of this.chipResponsable){
      if(element.id == $event.id){
        return false
      }
    }
      this.chipResponsable.push(
        {nombre:$event.providerName, id:$event.id})
  }

  clickFilaUsuarios($event: User) {
    //console.log($event)
    this.tipoResponsable='usuario'
    for(let element of this.chipResponsable){
      if(element.id == $event.userId){
        return false
      }
    }
      this.chipResponsable.push(
        {nombre:$event.name, id:$event.userId})
  }

  async finalizar() {
    for(let element of this.chipResponsable){
      let body = {
        userId:element.id,
        orderId:this.data.orderId,
        responsibleType:this.tipoResponsable
    }


    let res: GenericResponse = await this.http.postDataBody(`${this.urlPostUsuariosOT}`, body)
    //console.log(res)
    if(res){
      this.message.SuccessToast(`Encargado creado correctamente`)
      this.dialogRef.close()
    }
    }
  }


}
